module.exports = __webpack_public_path__ + "static/media/pic6.92754d53.jpg";